// UAT review mode flag. When enabled, review chips render on public pages so
// reviewers can see UAT content state. The flag is opt-in via either:
//   - `?review=1` (or any truthy value) on the URL — useful for sharing a
//     review-mode link with the testing group without changing the build.
//   - `windroosReview=1` in localStorage — persists across reloads on a single
//     device for a reviewer that uses the same browser repeatedly.
//
// Default: chips are hidden, matching what a normal UAT or production visitor
// should see. Dev/maintenance builds are NOT auto-opt-in because the chips
// otherwise leak into screenshots and reviewer feedback.

const STORAGE_KEY = "windroosReview";
const QUERY_KEYS = ["review", "uatReview", "windroosReview"];

function truthy(value) {
  if (value == null) return false;
  const v = String(value).toLowerCase();
  return v === "1" || v === "true" || v === "yes" || v === "on";
}

export function isReviewModeEnabled() {
  if (typeof window === "undefined") return false;

  try {
    const params = new URLSearchParams(window.location.search);
    for (const key of QUERY_KEYS) {
      if (params.has(key) && truthy(params.get(key))) return true;
    }
  } catch {
    // URLSearchParams is supported everywhere we care about; ignore parse errors.
  }

  try {
    if (truthy(window.localStorage?.getItem(STORAGE_KEY))) return true;
  } catch {
    // localStorage access can throw in private/embedded contexts; ignore.
  }

  return false;
}
